module.exports = __webpack_public_path__ + "img/spider_egg_nest_small.e57d9cc1.png";